import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

/**
 * Quill/Parchment Blot to allow hr tags
 * @class HrBlot
 * @extends BlockEmbed
 */
export class HrBlot extends BlockEmbed {

  /** @inheritdoc */
  static blotName: string = 'hr';

  /** @inheritdoc */
  static tagName: string = 'HR';

  /** @inheritdoc */
  static value(domNode) {
    return domNode;
  }

  /** @inheritdoc */
  static create(value) {
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/blots/hr/hr.blot.ts